const postStatuses = [
  {
    label: 'Rascunho',
    value: 'draft',
  },
  {
    label: 'Publicado',
    value: 'published',
  },
]

const postStatusesTranslations = {
  draft: 'Rascunho',
  published: 'Publicado',
}

export { postStatuses, postStatusesTranslations }
